import workerUrl from 'maplibre-gl/dist/maplibre-gl-worker.mjs?worker&url'
import { setWorkerUrl } from 'maplibre-gl'

/**
 * Tell MapLibre where its tile-parsing worker lives.
 *
 * MapLibre 6 derives that URL from its own `import.meta.url`, assuming it is
 * served as `maplibre-gl.mjs` with `maplibre-gl-worker.mjs` beside it. Bundled
 * by Vite it is neither, so the default resolves to
 * `/assets/maplibre-gl-worker.mjs` and 404s. The failure is quiet and easy to
 * misread: the style loads and the background layer paints, but no tile is
 * ever parsed, so the map is a blank sheet of colour.
 *
 * The worker also imports `./maplibre-gl-shared.mjs`, so it cannot simply be
 * copied as a static file — `?worker&url` makes Vite bundle it with its
 * dependencies and hand back the hashed URL of the result.
 *
 * Imported for its side effect, and it must run before the first `new Map()`.
 */
setWorkerUrl(workerUrl)
